module.exports = __webpack_public_path__ + "img/extended.83086599.png";